export default __webpack_public_path__ + "static/media/img_chart_grade_C-.27e73b9e7169c2c78b4d70d836c56399.svg";